import axios from "axios";

export function getEvents(s: string = '', passed_events: boolean = false) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/event';
    const params = [];
    if (s.length > 0) {
        params.push('s=' + s);
    }
    if (passed_events) {
        params.push('passed=1');
    }
    if (params.length > 0) {
        endpointUrl += '?' + params.join('&');
    }
    return axios.get(endpointUrl, { headers: headers } );
}

export function getEventOptions(s: string = '') {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/event/options';
    const params = [];
    if (s.length > 0) {
        params.push('s=' + s);
    }
    if (params.length > 0) {
        endpointUrl += '?' + params.join('&');
    }
    return axios.get(endpointUrl, { headers: headers } );
}

export function getEventSingle(id: number) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/event/' + id;
    return axios.get(endpointUrl, { headers: headers } );
}

export function createEvent(body_obj: any) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/event';
    return axios.post(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

export function updateEvent(body_obj: any) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/event';
    return axios.patch(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

export function deleteEvent(id: number) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/event/' + id;
    return axios.delete(endpointUrl, { headers: headers });
}